import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../api";
import { button } from "./style";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const email = searchParams.get("email") || "";

  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!token || !email) {
      toast.error("Invalid reset link. Please request a new link from the forgot password page.");
      return;
    }
    if (password.length < 8 || password.length > 10) {
      toast.error("Password must be 8–10 characters.");
      return;
    }
    if (password !== passwordConfirmation) {
      toast.error("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      await api.post("reset-password", {
        email,
        token,
        password,
        password_confirmation: passwordConfirmation,
      });
      setSuccess(true);
      toast.success("Password reset successfully. You can now log in.");
    } catch (err) {
      const msg = err.response?.data?.message || "This link may be invalid or expired. Please request a new one.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <Grid container sx={{ height: "100vh" }}>
        <Grid item xs={12} md={6} sx={{ bgcolor: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center", p: 4 }}>
          <Box sx={{ maxWidth: 400, textAlign: "center" }}>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 700, color: "#2e7d32" }}>Password reset successfully</Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>You can now log in with your new password.</Typography>
            <Button component={Link} to="/login" variant="contained" sx={{ backgroundColor: "#EF2A1E", "&:hover": { backgroundColor: "#EF2A1E" } }}>Back to login</Button>
          </Box>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Grid item xs={12} md={6} sx={{ backgroundImage: `url("/assets/images/signup-bg.png")`, backgroundSize: "cover", display: "flex", alignItems: "center", justifyContent: "center", p: 4 }} />
      <Grid item xs={12} md={6} sx={{ py: 6, px: { xs: 4, md: 6 }, display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <Box sx={{ maxWidth: 400 }}>
          <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}><Box component="span" sx={{ color: "#D6232A" }}>Reset password</Box></Typography>
          {(!token || !email) ? (
            <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>Invalid or missing reset link. Please use the link from your email or <Link to="/forgot-password">request a new one</Link>.</Typography>
          ) : (
            <Box component="form" onSubmit={onSubmit}>
              <TextField fullWidth label="Email" type="email" value={email} disabled sx={{ mb: 2 }} />
              <TextField fullWidth label="New password" type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="8–10 characters" sx={{ mb: 2 }} />
              <TextField fullWidth label="Confirm password" type={showPassword ? "text" : "password"} value={passwordConfirmation} onChange={(e) => setPasswordConfirmation(e.target.value)} sx={{ mb: 2 }} />
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button type="submit" disabled={loading} sx={{ ...button, backgroundColor: "#EF2A1E", color: "#fff" }}>{loading ? "Resetting…" : "Reset password"}</Button>
                <Button component={Link} to="/login" sx={{ color: "#666" }}>Cancel</Button>
              </Box>
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default ResetPassword;
